import { FormlyFieldConfig } from '@ngx-formly/core';
import { DetailsFormOptions } from './details-form-options.interface';
import { toFormlyOptions } from './details-form-helpers';

/**
 * SECTION 4.1: CO-APPLICANT PREQUALIFYING INFORMATION
 */
export function getCoApplicantPrequalifyingFields(options: DetailsFormOptions): FormlyFieldConfig[] {
  return [
    // Prequalifying
    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Co_App_Residency_Status',
          type: 'select',
          props: {
            label: 'Residency Status',
            options: toFormlyOptions(options.residencyStatuses$),
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Co_App_Employment_Type',
          type: 'select',
          props: {
            label: 'Employment Status',
            options: toFormlyOptions(options.employmentStatuses$),
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Co_App_BK_CC_CP',
          type: 'select',
          props: {
            label: 'Bankruptcy, Credit Counselling, Consumer Proposal',
            options: toFormlyOptions(options.bankruptcyOptions$),
          },
        },
      ],
    },
  ];
}